export const environment = {
    production: true,
    apiUrl: 'https://tgnv12.smartworkar.com:8888',
    frontUrl: '',
    urlAssets: 'http://localhost:4200',
    urlBack: 'https://tgn-evaluaciones-emyr-back.candoit.com.ar',
    //urlBack:'http://localhost:8083',
    user: {
        username: "tgntesting@vreadynow.com",
        password: "larealidadesvirtual"
    },
    userApi: {
        username: "user_api",
        password: "Hrfw567"
    },
    protocolName: ''


};